import AccountActionPage from '@/components/auth/AccountAction'
import SubscriptionPendingContainer from '@/checkout/components/post-checkout/SubscriptionPendingContainer'
import PasswordResetPage from '@/routes/password/PasswordResetPage'
import SignInPage from '@/routes/sign-in/SignInPage'
import SignUpPage from '@/routes/sign-up/SignUpPage'
import InvitePage from '@/routes/invite/InvitePage'
import type { RouteFactory } from '@/routing/types'
import PostSignupPhonePage from '@/routes/complete-signup/PostSignupPhonePage'
import AuthSignInPage from '@/auth/components/SignInPage'
import CreateAccountPage from '@/auth/components/CreateAccountPage'
import { kFeatureFlags, kGetFeatureFlagStatus } from '@/constants/constants-feature-flags'
import { AuthCredentialsProvider } from '@/auth/components/AuthCredentialsProvider'

/**
 * Creates authentication-related routes.
 */
export const createAuthRoutes: RouteFactory = () => {
  const showRefreshedAuthPages = kGetFeatureFlagStatus(kFeatureFlags.ONBOARDING_REFRESH_AUTH_PAGES)

  return [
    ...(showRefreshedAuthPages
      ? [
          {
            element: <AuthCredentialsProvider />,
            children: [
              { path: 'sign-in', element: <AuthSignInPage /> },
              { path: 'sign-up', element: <CreateAccountPage /> },
            ],
          },
        ]
      : [
          { path: 'sign-in', element: <SignInPage /> },
          { path: 'sign-up', element: <SignUpPage /> },
        ]),
    {
      path: 'forgot-password',
      element: <PasswordResetPage />,
    },
    {
      path: 'invite/:inviteId?',
      element: <InvitePage />,
    },
    {
      path: 'account-action',
      element: <AccountActionPage />,
    },
    {
      path: 'pending-subscription',
      element: <SubscriptionPendingContainer />,
    },
    {
      path: 'complete-signup/phone',
      element: <PostSignupPhonePage />,
    },
  ]
}
